<div>
	<div *ngIf="isAddOrganization">
	
		<div>
			<his-plam label="{{'fs.res.common.organizations.historized'|hisUi}}" [hisDdKey]="ddKey">
				<p-autoComplete #content appendTo="body"
					[forceSelection]="true"
					field="text"
					[dropdown]="true" 
					[(ngModel)]="selectedOrganization"
					[suggestions]="filteredOptions"
					(completeMethod)="completeMethod($event)"
					(onSelect)="onSelect($event.value)">
				</p-autoComplete>
			</his-plam>
		</div>
	</div>
	
	<ng-container *ngIf="showSelectionBelow">
		<div *ngIf="organizations.length > 0">
			<h4>{{ (organizations.length > 1 ? 'fs.res.common.organizations.historized.assignedHistorizedOrgUnit_plural' : 'fs.res.common.organizations.historized.assignedHistorizedOrgUnit') | hisUi }}</h4>
			
			<p-table [value]="organizations">
				<ng-template pTemplate="header">
					<tr>
						<th>{{ 'fs.res.finance.project.table.header.organizationUnit' | hisUi }}</th>
				    	<th>{{'common.actions' | hisUi }}</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-orgunit>
					<tr>
				    	<td>{{orgunit.text}}</td>
				        <td class="singleLine">
							<button (click)="deleteOrganization(orgunit)" hisImage="DELETE" class="icon" [title]="'view.controls.disconnect' | hisUi"></button>		            
				        </td>
				    </tr>
				</ng-template>
			</p-table>
		</div>
	</ng-container>
	
</div>